import React from 'react';
import { resolveProductMediaUrl } from '../../../services/apiService';

export default function UsedVerificationPhotoSection({
  verificationPhoto,
  onPayNow,
  paying,
}) {
  if (!verificationPhoto?.url) return null;

  const src = resolveProductMediaUrl(verificationPhoto.url);

  return (
    <section className="rounded-2xl border border-emerald-700/50 bg-emerald-950/20 p-4 sm:p-5">
      <p className="text-[11px] font-bold uppercase tracking-[0.15em] text-emerald-400">
        Seller verification photo
      </p>
      <p className="mt-2 text-sm text-emerald-100/90">
        The seller checked this part and sent a photo. Review it before you pay.
      </p>

      <div className="mt-4 overflow-hidden rounded-xl border border-slate-700/60 bg-slate-900">
        <img
          src={src}
          alt="Verification photo from seller"
          className="max-h-80 w-full object-contain"
        />
      </div>

      {verificationPhoto.canPayNow && (
        <button
          type="button"
          onClick={onPayNow}
          disabled={paying}
          className="mt-4 w-full rounded-xl bg-amber-500 px-5 py-3.5 text-base font-bold text-slate-900 hover:bg-amber-400 disabled:opacity-50 sm:w-auto"
        >
          {paying ? 'Please wait…' : 'Pay now'}
        </button>
      )}
    </section>
  );
}
